import styles from './style.postcss';

import React from 'react';
import classnames from 'classnames';
import { ProgressBar } from 'omni-common-ui';
import PropTypes from 'prop-types';

const ProgressBarTd = (props) => <td className={classnames(styles.ProgressBarTd, props.className)}>
  <ProgressBar className={styles.ProgressBarTd_ProgressBar}
      value={props.percent}
      max={100}
      larger
      rounded />
  {
    ! props.isHideText &&
    <div className={styles.ProgressBarTd_Percent}>
      {props.progressValue ? props.progressValue : `${props.percent ? props.percent : 0}%`}
    </div>
  }
</td>;

ProgressBarTd.propTypes = {
  percent: PropTypes.number,
  className: PropTypes.string,
  progressValue: PropTypes.string,
  isHideText: PropTypes.bool,
};

export default ProgressBarTd;



// WEBPACK FOOTER //
// ./components/TableView/Tds/ProgressBarTd/index.jsx